"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const createPollQuestion = (0, graphql_tag_1.default)`
  mutation polls_createPollQuestion($question: PollQuestionInput) {
    polls {
      createPollQuestion(question: $question) {
        id
        pollId
        questionType
        title
        hasOther
        questionItems {
          id
          itemValue
          isOther
        }
        attachments {
          id
          name
          path
        }
      }
    }
  }
`;
exports.default = createPollQuestion;